// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import TermsAndConditions from '../terms-and-conditions/TermsAndConditions';
import {actions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    isFetchingTerms: state.legalConfig.isFetchingTerms,
    isSaving: state.legalConfig.isSaving,
    saveTermsSuccess: state.legalConfig.saveTermsSuccess,
    saveTermsError: state.legalConfig.saveTermsError,
    terms: state.legalConfig.terms,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(TermsAndConditions);
